<!--<bringoz-icon class="hide-for-mobile"-->
<!--        [classSize]="'xl'"-->
<!--        [iconName]="address.qualityGroup.toLowerCase() === 'low' ? 'location-pin-check-outline-no' : 'location-pin-check-outline'"-->
<!--        [fill]="qualityGroupFill[address.qualityGroup.toLowerCase()]"-->
<!--        (click)="onSelectAddress($event)"-->
<!--        [ngbTooltip]="addressQualityTooltip" openDelay="300" triggers="hover">-->
<!--</bringoz-icon>-->

<bringoz-icon *ngIf="canViewResolver && address"
              [ngClass]="{'updateable': canUpdateResolver}"
              [classSize]="'sm'"
              [iconName]="address.qualityGroup?.toLowerCase() === 'low' ? 'location-pin-check-outline-no' : 'location-pin-check-outline'"
              [fill]="qualityGroupFill[address.qualityGroup?.toLowerCase() || 'none']"
              (click)="onSelectAddress($event)"
              [ngbTooltip]="addressQualityTooltip" openDelay="300" triggers="hover" container="body"
              placement="top">
</bringoz-icon>

<ng-template #addressQualityTooltip>
  <div class="layout-column layout-align-start-center">

    <div *ngIf="type == addressRequestType.Planning" class="layout-column layout-align-start-center">
      <span class="br-body-2">
        {{'Action will not affect jobs with the same address in other existing projects'| translate}}
      </span>
    </div>

    <div *ngIf="address.qualityGroup" class="layout-column layout-align-start-center gap-5">
      <span class="br-body-2">
        {{'Address solving rate' | translate}}:
      </span>
      <span class="br-body-2">
        {{(address.qualityGroup + ' quality') | translate}}
      </span>
    </div>

    <div *ngIf="address.resolvedBy" class="layout-column layout-align-start-center">
      <span class="br-body-2">
        {{'Resolved By'}}: {{address.resolvedBy}}
      </span>
    </div>

    <div *ngIf="address.resolvingType" class="layout-column layout-align-start-center">
      <span class="br-body-2">
        {{'Resolving Type'}}: {{address.resolvingType}}
      </span>
    </div>
  </div>
</ng-template>
